import { render, staticRenderFns } from "./end-done.vue?vue&type=template&id=5b18f44c&scoped=true"
import script from "./end-done.vue?vue&type=script&lang=js"
export * from "./end-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b18f44c",
  null
  
)

export default component.exports